// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import AppStoreWhiteBg from '../_raw/ui/icon_app_store_white_bg.svg';
import withIconProps from '../withIconProps';

export default withIconProps(AppStoreWhiteBg, { shouldSetDefaultSize: false });
